const LOCAL_SITE_URL = "http://localhost:3000";

const isBlankConfigValue = (value: string | undefined): value is undefined => {
  return !value || value === "undefined" || value === "null";
};

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

const getPublicWebuiUrl = (): string | undefined => {
  if (typeof window !== "undefined") {
    return (
      (window as typeof window & { __RUNTIME_CONFIG__?: Record<string, string | undefined> }).__RUNTIME_CONFIG__?.[
        "NEXT_PUBLIC_WEBUI_URL"
      ] || process.env.NEXT_PUBLIC_WEBUI_URL
    );
  }

  return process.env.NEXT_PUBLIC_WEBUI_URL;
};

export const getSiteBaseUrl = (): string => {
  const candidates = [process.env.WEBUI_URL, getPublicWebuiUrl(), process.env.NEXT_PUBLIC_SITE_URL];
  const configuredUrl = candidates.find((value) => !isBlankConfigValue(value));

  return configuredUrl ? trimTrailingSlash(configuredUrl) : LOCAL_SITE_URL;
};

export const getCanonicalPath = (path: string = "/"): string => {
  const pathWithoutQuery = path.split("?")[0].split("#")[0] || "/";

  return pathWithoutQuery.startsWith("/") ? pathWithoutQuery : `/${pathWithoutQuery}`;
};

export const getAbsoluteSiteUrl = (path: string = "/"): string => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getSiteBaseUrl()}${normalizedPath}`;
};

export const getCanonicalSiteUrl = (path: string = "/"): string => {
  if (/^https?:\/\//i.test(path)) {
    const url = new URL(path);
    return `${url.origin}${url.pathname}`;
  }

  return getAbsoluteSiteUrl(getCanonicalPath(path));
};
